import { Action } from 'redux';
import {
  FETCH_DATA_INGREDIENTS_REQUEST,
  FETCH_DATA_INGREDIENTS_SUCCESS,
  FETCH_DATA_INGREDIENTS_ERROR,

  GET_MY_INGREDIENTS_LOCAL,
  UPDATE_MY_INGREDIENTS_LOCAL_BY_LANG,
  FETCH_DATA_MY_INGREDIENTS_REQUEST,
  FETCH_DATA_MY_INGREDIENTS_SUCCESS,
  FETCH_DATA_MY_INGREDIENTS_ERROR,
  PREPEND_MY_INGREDIENTS,
  REMOVE_MY_INGREDIENTS,
  SORT_DATA_MY_INGREDIENTS,

  SET_MY_INGREDIENTS_REQUEST_LOCAL,
  GET_MY_INGREDIENTS_REQUEST_LOCAL,
  UPDATE_MY_INGREDIENTS_REQUEST_LOCAL_BY_LANG,

  UPDATE_MY_INGREDIENTS_REQUEST,
  UPDATE_MY_INGREDIENTS_SUCCESS,
  UPDATE_MY_INGREDIENTS_ERROR,

  REQUEST_INGREDIENT_REQUEST,
  REQUEST_INGREDIENT_SUCCESS,
  REQUEST_INGREDIENT_ERROR,
  REQUEST_INGREDIENT_RESET,

  FETCH_DATA_FLAVORS_REQUEST,
  FETCH_DATA_FLAVORS_SUCCESS,
  FETCH_DATA_FLAVORS_ERROR,
} from './actions';

export const UpdateMyIngredientActionEnum = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
}

export interface Data {
  id: number;
  name: string;
  description: string;
}

export type TIngredient = {
  id: number;
  name: string;
  image?: string;
  created_at?: string;
}

type TIngredientTranslate = {
  id: number;
  name: string;
  ingredient_id: number;
  lang_id: number;
  created_at: string;
  updated_at: string;
  deleted_at: string;
}
export type TMyIngredientResponse = {
  id: number;
  icon: string;
  name: string;
  state: string;
  created_at: string;
  updated_at: string;
  deleted_at: string;
  translates: TIngredientTranslate[];
}

export type THistoryResponse = {
  id: number;
  analyze_type: string;
  analyze_title: string;
  created_at: string;
  files: any;
  response_meals: any;
  response_ingredients: any;
}

type TFlavorTranslate = {
  flavor_id: number,
  name: string,
  lang_id: number
}

type TFlavorItemTranslate = {
  flavor_item_id: number,
  name: string,
  lang_id: number,
}
export interface TFlavorItemResponse {
  id: number,
  flavor_id: number,
  translates: TFlavorItemTranslate[]
}
export interface TFlavorResponse {
  id: number,
  sort: number,
  translates: TFlavorTranslate[],
  flavor_items: TFlavorItemResponse[]
}
export interface TFlavorItem {
  id: number,
  name: string
}
export interface TFlavor {
  id: number,
  sort: number,
  name: string,
  flavor_items: TFlavorItem[]
}

export interface THistory {
  id: number,
  name: string,
}

export type TFravor = any
export type TRecipe = any

export type TOption = {
  value: string,
  label: string,
}

// list all ingredients
export type FetchDataIngredientsAction = Action<typeof FETCH_DATA_INGREDIENTS_REQUEST>

export interface FetchDataIngredientsSuccessAction
  extends Action<typeof FETCH_DATA_INGREDIENTS_SUCCESS> {
    payload: TIngredient[];
  }

export interface FetchDataIngredientsErrorAction
  extends Action<typeof FETCH_DATA_INGREDIENTS_ERROR> {
    payload: Error;
  }

// list my ingredients
export interface TRequestMyIngredients {
  user_id: number,
  lang: string,
}
export interface GetDataMyIngredientsLocalAction
  extends Action<typeof GET_MY_INGREDIENTS_LOCAL> {
    payload: TRequestMyIngredients;
  }
export interface UpdateDataMyIngredientsLocalAction
  extends Action<typeof UPDATE_MY_INGREDIENTS_LOCAL_BY_LANG> {
    payload: {
      data: TIngredient[]
    } & TRequestMyIngredients;
  }
export type FetchDataMyIngredientsAction = Action<typeof FETCH_DATA_MY_INGREDIENTS_REQUEST>

export interface FetchDataMyIngredientsSuccessAction
  extends Action<typeof FETCH_DATA_MY_INGREDIENTS_SUCCESS> {
    payload: TIngredient[];
  }

export interface FetchDataMyIngredientsErrorAction
  extends Action<typeof FETCH_DATA_MY_INGREDIENTS_ERROR> {
    payload: Error;
  }

export type TPrependMyIngredientsAction = TRequestMyIngredients & {
  items: TIngredient[],
}
export interface PrependMyIngredientsAction
  extends Action<typeof PREPEND_MY_INGREDIENTS> {
    payload: TPrependMyIngredientsAction;
  }

export type TRemoveMyIngredientsAction = TRequestMyIngredients & {
  ids: number[]
};
export interface RemoveMyIngredientsAction
  extends Action<typeof REMOVE_MY_INGREDIENTS> {
    payload: TRemoveMyIngredientsAction;
  }

export interface SortMyIngredientsAction
  extends Action<typeof SORT_DATA_MY_INGREDIENTS> {
    payload: TOption
  }

export interface SetDataMyIngredientsRequestLocalAction
  extends Action<typeof SET_MY_INGREDIENTS_REQUEST_LOCAL> {
    payload: {
      data: TIngredient[]
    } & TRequestMyIngredients;
  }
export interface GetDataMyIngredientsRequestLocalAction
  extends Action<typeof GET_MY_INGREDIENTS_REQUEST_LOCAL> {
    payload: TRequestMyIngredients;
  }
export interface UpdateDataMyIngredientsRequestLocalAction
  extends Action<typeof UPDATE_MY_INGREDIENTS_REQUEST_LOCAL_BY_LANG> {
    payload: {
      data: TIngredient[]
    } & TRequestMyIngredients;
  }

// update list my ingredients
export type TRequestUpdateMyIngredients = {
  ids: number[],
  action: typeof UpdateMyIngredientActionEnum[keyof typeof UpdateMyIngredientActionEnum]
}
export interface UpdateMyIngredientsAction
  extends Action<typeof UPDATE_MY_INGREDIENTS_REQUEST> {
    payload: TRequestUpdateMyIngredients
  }

export interface UpdateMyIngredientsSuccessAction
  extends Action<typeof UPDATE_MY_INGREDIENTS_SUCCESS> {
    payload: TIngredient[];
  }

export interface UpdateMyIngredientsErrorAction
  extends Action<typeof UPDATE_MY_INGREDIENTS_ERROR> {
    payload: Error;
  }

// requset new ingradient
export type TRequestNewIngradient = {
  ingredient_name: string,
}
export interface RequestNewIngradientAction
  extends Action<typeof REQUEST_INGREDIENT_REQUEST> {
    payload: TRequestNewIngradient
  }

export interface RequestNewIngradientSuccessAction
  extends Action<typeof REQUEST_INGREDIENT_SUCCESS> {
    payload: TIngredient;
  }

export interface RequestNewIngradientErrorAction
  extends Action<typeof REQUEST_INGREDIENT_ERROR> {
    payload: Error;
  }

export type RequestNewIngradientResetAction = Action<typeof REQUEST_INGREDIENT_RESET>

// list all flavors
export type FetchDataFlavorsAction = Action<typeof FETCH_DATA_FLAVORS_REQUEST>

export interface FetchDataFlavorsSuccessAction
  extends Action<typeof FETCH_DATA_FLAVORS_SUCCESS> {
    payload: TFravor[];
  }

export interface FetchDataFlavorsErrorAction
  extends Action<typeof FETCH_DATA_FLAVORS_ERROR> {
    payload: Error;
  }
